/* Green Haze — catálogo y cesta contra Shopify de verdad.

   Sustituye al script de la maqueta, que llevaba los 26 productos escritos a
   mano y un carrito de mentira. Aquí:
     · las fichas las pinta Liquid desde los productos reales
     · la báscula de gramos usa las variantes «Gramos» de cada producto, con su
       precio real: no se calcula ningún descuento a mano
     · añadir a la cesta va por /cart/add.js
     · la cesta se lee de /cart.js y el pago va al checkout nativo
*/
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const eur = c => (c / 100).toLocaleString('es-ES',
    { style: 'currency', currency: window.GH_MONEDA || 'EUR' });

  /* Las rutas las inyecta el layout desde Liquid. No se pueden escribir a mano:
     la tienda tiene mercados e idiomas, así que llevan prefijo (/es/cart/add.js)
     y una ruta fija fallaría en cuanto alguien navega en otro idioma. */
  const R = window.routes || {};
  const ruta = (clave, porDefecto) => (R[clave] || porDefecto);

  function toast(msg) {
    const t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('on'), 2600);
  }

  /* ── báscula de gramos ─────────────────────────────────────────
     Cada tramo es una variante. El precio por gramo se saca del propio
     precio de la variante, así el ahorro que se muestra es el real. */
  function bascula(caja) {
    const ticks = $$('.ladder-tick', caja);
    if (!ticks.length) return;
    const total = $('[data-total]', caja);
    const unidad = $('[data-unit]', caja);
    const tramo = $('[data-tramo]', caja);
    const ahorro = $('[data-ahorro]', caja);
    const pulgar = $('[data-thumb]', caja);
    const base = parseInt(ticks[0].dataset.price, 10) /
                 (parseFloat(ticks[0].dataset.title) || 1);

    function pinta(i) {
      const t = ticks[i];
      const gramos = parseFloat(t.dataset.title) || 1;
      const precio = parseInt(t.dataset.price, 10);
      const porGramo = precio / gramos;

      ticks.forEach((x, n) => x.setAttribute('aria-pressed', n === i ? 'true' : 'false'));
      if (total) total.textContent = eur(precio);
      if (unidad) unidad.textContent = eur(porGramo) + '/g';
      if (tramo) tramo.textContent = t.dataset.title;
      if (ahorro) {
        const dto = Math.round((1 - porGramo / base) * 100);
        ahorro.textContent = dto > 0 ? `−${dto} % por gramo` : '';
      }
      if (pulgar) {
        pulgar.style.left = `calc(${i} * (100% - 6px) / ${ticks.length} + 3px)`;
      }
      caja.dataset.vid = t.dataset.vid;
      caja.dataset.agotado = t.dataset.agotado || '';

      /* En la ficha de producto el formulario nativo lleva la variante en un
         campo oculto. Hay que moverlo también, o al enviar sin JavaScript se
         añadiría siempre el primer tramo. */
      const oculto = document.querySelector('[data-variante]');
      if (oculto) oculto.value = t.dataset.vid;
    }

    ticks.forEach((t, i) => {
      if (t.dataset.agotado) return;   // agotado: no se puede elegir
      t.addEventListener('click', () => pinta(i));
    });
    /* Arrancar en el primer tramo DISPONIBLE. Si se arranca en el primero a
       secas y ese está agotado, al pulsar «Añadir» Shopify responde 422 y el
       cliente ve un error sin entender por qué. */
    const libre = ticks.findIndex(t => !t.dataset.agotado);
    pinta(libre === -1 ? 0 : libre);
  }

  /* ── cesta ─────────────────────────────────────────────────── */
  async function leerCesta() {
    const r = await fetch(`${ruta('cart_url', '/cart')}.js`,
      { headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('No se ha podido leer la cesta');
    return r.json();
  }

  async function anadir(vid, cantidad = 1) {
    const r = await fetch(`${ruta('cart_add_url', '/cart/add')}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: cantidad }] }),
    });
    if (!r.ok) {
      let msg = 'No se ha podido añadir a la cesta.';
      try { const e = await r.json(); if (e.description) msg = e.description; } catch (_) {}
      throw new Error(msg);
    }
    return r.json();
  }

  async function cambiar(clave, cantidad) {
    const r = await fetch(`${ruta('cart_change_url', '/cart/change')}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: clave, quantity: cantidad }),
    });
    if (!r.ok) throw new Error('No se ha podido actualizar la cesta');
    return r.json();
  }

  function pintaCesta(cesta) {
    const insignia = $('#badge');
    if (insignia) {
      insignia.textContent = cesta.item_count;
      insignia.classList.toggle('on', cesta.item_count > 0);
    }
    const cuerpo = $('#cart-body');
    const pie = $('#cart-foot');
    if (!cuerpo) return;

    if (!cesta.item_count) {
      cuerpo.innerHTML = `<div style="padding:52px 0;text-align:center">
        <p class="h-md">La cesta está vacía</p>
        <p class="lede" style="font-size:14px;margin:12px 0 22px">Elige una variedad y ajusta los gramos: el precio se recalcula solo.</p>
        <button class="btn btn-sec btn-sm" data-close>Ver el catálogo</button></div>`;
      if (pie) pie.hidden = true;
      return;
    }
    if (pie) pie.hidden = false;

    cuerpo.innerHTML = cesta.items.map(l => `
      <div class="line" data-key="${l.key}">
        ${l.image ? `<img class="line-img" src="${l.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2')}" alt="" width="60" height="60" loading="lazy">` : ''}
        <div class="line-info">
          <a class="line-name" href="${l.url}">${l.product_title}</a>
          <span class="line-meta">${l.variant_title || ''}</span>
          <div class="line-qty">
            <button class="qty-btn" data-menos aria-label="Quitar uno">−</button>
            <span>${l.quantity}</span>
            <button class="qty-btn" data-mas aria-label="Añadir uno">+</button>
          </div>
        </div>
        <div class="line-price">${eur(l.final_line_price)}</div>
      </div>`).join('');

    /* Los ids reales del drawer son #sub / #ship / #total (ver
       snippets/gh-overlays.liquid). El código usaba #cart-sub / #cart-ship,
       que no existen en el HTML, así que nunca actualizaba nada: el
       subtotal y el total se quedaban en el «0,00 €» de partida del
       markup aunque el pedido sí llevara el importe real (por eso el
       precio de la línea se veía bien, pero el total no). */
    const umbral = (window.GH_ENVIO_GRATIS || 50) * 100;
    const falta = umbral - cesta.total_price;

    const sub = $('#sub');
    const subtotalBruto = cesta.items_subtotal_price ?? cesta.total_price;
    if (sub) sub.textContent = eur(subtotalBruto);

    const total = $('#total');
    if (total) total.textContent = eur(cesta.total_price);

    /* Antes el subtotal ya salía descontado (usaba total_price para las
       dos cosas) sin ningún aviso de que se había aplicado un código, así
       que parecía que el descuento no hacía nada. Ahora el subtotal es el
       importe SIN descontar y se añade una línea aparte con el descuento
       real, usando el nombre del propio código. */
    const descRow = $('#cart-discount-row');
    if (descRow) {
      const descuento = cesta.total_discount || 0;
      if (descuento > 0) {
        /* OJO: /cart.js trae los datos en app.title/value, pero
           /cart/update.js (el que usa el formulario de código a mano) los
           anida distinto, en app.discount_application.title/value. Sin
           este segundo caso salía «Descuento (Descuento)» en vez del
           nombre real del código. */
        const app = (cesta.cart_level_discount_applications || [])[0];
        const info = app?.discount_application || app;
        const label = $('#cart-discount-label');
        const amt = $('#cart-discount-amt');
        /* Se muestra el porcentaje del descuento en vez del código en sí
           (p. ej. «Descuento (-15%)» en vez de «Descuento (GH-001)»),
           porque este cuadro vale para cualquier código que se aplique,
           no solo GH-001, y el código en crudo queda feo en la cesta. */
        let etiqueta = 'Descuento';
        if (info?.value_type === 'percentage' && info?.value) {
          etiqueta = `Descuento (-${info.value.replace('.0', '')}%)`;
        } else if (info?.title) {
          etiqueta = `Descuento (${info.title})`;
        }
        if (label) label.textContent = etiqueta;
        if (amt) amt.textContent = `-${eur(descuento)}`;
        descRow.hidden = false;
      } else {
        descRow.hidden = true;
      }
    }

    const envio = $('#ship');
    if (envio) envio.textContent = falta > 0 ? 'Calculado al pagar' : 'Gratis';

    const shipMsg = $('#ship-msg');
    if (shipMsg) {
      shipMsg.textContent = falta > 0
        ? `Te faltan ${eur(falta)} para el envío gratis`
        : '¡Envío gratis conseguido!';
    }

    const shipFill = $('#ship-fill');
    if (shipFill) {
      const pct = Math.min(100, (cesta.total_price / umbral) * 100);
      shipFill.style.width = `${pct}%`;
    }
  }

  async function refrescar() {
    try { pintaCesta(await leerCesta()); } catch (e) { console.warn(e); }
  }

  /* ── capas ─────────────────────────────────────────────────── */
  function cerrarTodo() {
    ['#drawer', '#sheet', '#mnav', '#pop'].forEach(s => $(s)?.classList.remove('on'));
    $('#veil')?.classList.remove('on');
    document.body.classList.remove('locked');
  }
  function abrirCesta() {
    $('#drawer')?.classList.add('on');
    $('#veil')?.classList.add('on');
    document.body.classList.add('locked');
  }

  /* ── popup del 15% ─────────────────────────────────────────────
     Estaba en el HTML/CSS pero sin ningún JS que lo mostrara: nunca
     salía (por eso el cliente se suscribió por el formulario de abajo,
     no por este popup). Ahora: aparece una vez pasados unos segundos,
     no vuelve a salir si ya se cerró o si ya se suscribió, y usa el
     mismo velo que la cesta/el menú. */
  function popup() {
    const pop = $('#pop');
    if (!pop) return;
    const VISTO = 'gh_pop_visto';
    const marcar = () => {
      try { localStorage.setItem(VISTO, '1'); } catch (_) {}
      cerrarTodo();
    };

    /* El botón de cerrar (#pop-x) tiene que quedar enganchado SIEMPRE,
       tanto si el popup se abre por el temporizador como si se abre
       porque acaba de confirmarse una suscripción (ver más abajo). Antes
       se enganchaba solo en la rama del temporizador, así que en la
       pantalla de «¡Listo!» la X no hacía nada. */
    $('#pop-x')?.addEventListener('click', marcar);
    $('#pop-form')?.addEventListener('submit', marcar);
    $('#veil')?.addEventListener('click', () => { if (pop.classList.contains('on')) marcar(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && pop.classList.contains('on')) marcar();
    });

    /* Si esta carga de página es justo la confirmación de un envío
       (el `{% if form.posted_successfully? %}` de Liquid), se marca
       como visto para no volver a pedirle el email a quien ya se
       acaba de suscribir, y de paso se le enseña el mensaje una vez. */
    const yaConfirmado = !!$('[data-pop-ok]', pop);
    if (yaConfirmado) {
      marcar();
      pop.classList.add('on');
      $('#veil')?.classList.add('on');
      document.body.classList.add('locked');
      return;
    }

    let visto = false;
    try { visto = !!localStorage.getItem(VISTO); } catch (_) { visto = false; }
    if (visto) return;

    setTimeout(() => {
      if (pop.classList.contains('on')) return; // ya se abrió otra capa encima
      pop.classList.add('on');
      $('#veil')?.classList.add('on');
      document.body.classList.add('locked');
    }, 7000);
  }

  /* ── filtro por categoría y buscador del catálogo ─────────────
     En escritorio se ven todas las fichas que cumplan el filtro, como
     siempre. En móvil (<=820px, el mismo corte que ya usa el resto del
     tema) se muestran de 6 en 6 con un botón «Ver más», para no obligar
     a bajar y bajar hasta ver las 26 variedades de golpe. */
  function filtros() {
    const rejilla = $('#grid');
    if (!rejilla) return;
    const fichas = $$('.card', rejilla);
    const vacio = $('#grid-empty');
    const btnMas = $('#ver-mas');
    const PORTANDA = 6;
    let cat = 'todo', texto = '', tanda = 1;

    const esMovil = () => window.matchMedia('(max-width:820px)').matches;

    function aplica() {
      const coinciden = fichas.filter(f => {
        const okCat = cat === 'todo' || (f.dataset.cats || '').includes(cat);
        const okTxt = !texto || f.dataset.nombre.includes(texto);
        return okCat && okTxt;
      });

      const limite = esMovil() ? tanda * PORTANDA : coinciden.length;
      const mostrar = new Set(coinciden.slice(0, limite));
      fichas.forEach(f => { f.hidden = !mostrar.has(f); });

      if (vacio) vacio.hidden = coinciden.length > 0;
      const info = $('#mas-info');
      const mostrados = Math.min(limite, coinciden.length);
      if (info) info.textContent = `${mostrados} de ${fichas.length} variedades`;
      if (btnMas) btnMas.hidden = !esMovil() || mostrados >= coinciden.length;
    }

    $$('[data-cat]').forEach(b => b.addEventListener('click', () => {
      cat = b.dataset.cat;
      tanda = 1;
      $$('[data-cat]').forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      aplica();
    }));
    const buscar = $('#q');
    if (buscar) buscar.addEventListener('input', () => {
      texto = buscar.value.trim().toLowerCase();
      tanda = 1;
      aplica();
    });
    btnMas?.addEventListener('click', () => { tanda++; aplica(); });
    window.addEventListener('resize', aplica);
    aplica();
  }

  /* ── arranque ──────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    $$('[data-ladder]').forEach(bascula);
    filtros();
    popup();
    refrescar();

    // añadir a la cesta
    document.addEventListener('click', async e => {
      const boton = e.target.closest('[data-add]');
      if (!boton) return;
      /* En la ficha el botón es un submit dentro del formulario nativo: sin
         esto se añadiría dos veces, una por el envío y otra por el fetch. */
      e.preventDefault();
      const caja = $(`[data-ladder="${boton.dataset.add}"]`);
      const vid = caja?.dataset.vid;
      if (!vid) return toast('Elige primero los gramos.');
      if (caja.dataset.agotado) return toast('Ese tramo está agotado.');
      boton.disabled = true;
      try {
        await anadir(vid);
        await refrescar();
        abrirCesta();
        toast('Añadido a la cesta');
      } catch (err) {
        toast(err.message);
      } finally {
        boton.disabled = false;
      }
    });

    // cantidades y vaciar línea
    $('#cart-body')?.addEventListener('click', async e => {
      const linea = e.target.closest('.line');
      if (!linea) return;
      const mas = e.target.closest('[data-mas]');
      const menos = e.target.closest('[data-menos]');
      if (!mas && !menos) return;
      const actual = parseInt($('.line-qty span', linea).textContent, 10);
      try {
        pintaCesta(await cambiar(linea.dataset.key, mas ? actual + 1 : actual - 1));
      } catch (err) { toast(err.message); }
    });

    /* Valoraciones: se muestran de tres en tres y van rotando, como en la
       maqueta. Se respeta «reducir movimiento» del sistema y la rotación se
       detiene al pasar el ratón o al enfocar con el teclado, para poder leer. */
    (() => {
      const caja = $('#quotes');
      if (!caja) return;
      const fichas = $$('.quote', caja);
      const porPagina = Math.max(1, parseInt(caja.dataset.visibles || '3', 10));
      if (fichas.length <= porPagina) return;         // no hay nada que rotar

      const paginas = Math.ceil(fichas.length / porPagina);
      let pagina = 0, timer = null;

      function pinta() {
        fichas.forEach((f, i) => {
          const dentro = Math.floor(i / porPagina) === pagina;
          f.hidden = !dentro;
        });
      }
      const avanzar = () => { pagina = (pagina + 1) % paginas; pinta(); };

      const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const segundos = Math.max(3, parseInt(caja.dataset.segundos || '6', 10));
      const autoriza = caja.dataset.rotar === '1' && !quieto;

      function arranca() {
        if (!autoriza || timer) return;
        timer = setInterval(avanzar, segundos * 1000);
        boton?.setAttribute('aria-pressed', 'false');
      }
      function para() {
        clearInterval(timer); timer = null;
        boton?.setAttribute('aria-pressed', 'true');
      }

      const boton = $('#rev-toggle');
      if (boton) {
        boton.hidden = !autoriza;
        boton.addEventListener('click', () => (timer ? para() : arranca()));
      }
      // al leer, no se mueve
      caja.addEventListener('mouseenter', () => timer && para());
      caja.addEventListener('mouseleave', arranca);
      caja.addEventListener('focusin', () => timer && para());

      pinta();
      arranca();
    })();

    /* Vídeo de portada. El CSS lo deja en opacity:0 a propósito para que no
       aparezca a trompicones; hay que revelarlo cuando ya tiene imagen. */
    (() => {
      const v = document.getElementById('hero-video');
      if (!v || v.tagName !== 'VIDEO') return;
      const mostrar = () => v.classList.add('listo');
      if (v.readyState >= 2) mostrar();
      v.addEventListener('loadeddata', mostrar);
      v.addEventListener('canplay', mostrar);
      v.play?.().catch(() => mostrar());   // si el navegador bloquea el autoplay

      const boton = $('#vid-toggle');
      if (boton) boton.addEventListener('click', () => {
        const pausado = v.paused;
        if (pausado) v.play(); else v.pause();
        boton.setAttribute('aria-pressed', pausado ? 'false' : 'true');
        boton.setAttribute('aria-label', pausado ? 'Pausar el vídeo de fondo' : 'Reanudar el vídeo de fondo');
      });
    })();

    /* Selector de variedad.
       La recomendación no se calcula: viene de la matriz que ha dado la tienda
       (window.GH_MATRIZ, 18 combinaciones), igual que en la maqueta. Antes lo
       deducía yo del nivel de CBD y del aroma, y no coincidía con la cata. */
    (() => {
      const caja = $('#selector');
      if (!caja) return;
      const MATRIZ = window.GH_MATRIZ || {};
      const fichas = $$('#grid .card');
      const elegido = {};

      const clave = () => `${elegido.momento}|${elegido.formato}|${elegido.sabor}`;

      function pinta() {
        $$('[data-quiz]', caja).forEach(grupo => {
          const k = grupo.dataset.quiz;
          $$('.chip', grupo).forEach(chip => {
            chip.hidden = false;
            chip.setAttribute('aria-pressed', elegido[k] === chip.dataset.v ? 'true' : 'false');
          });
        });

        const texto = $('#quiz-texto'), res = $('#quiz-resultado');
        const completo = elegido.momento && elegido.formato && elegido.sabor;
        const handle = completo ? MATRIZ[clave()] : null;

        if (!handle) {
          if (texto) {
            texto.hidden = false;
            texto.textContent = completo
              ? 'Para esa combinación no tenemos recomendación ahora mismo.'
              : 'Marca las tres respuestas y te enseñamos la variedad que mejor encaja, con su precio.';
          }
          if (res) { res.hidden = true; res.innerHTML = ''; }
          return;
        }

        const g = fichas.find(f => f.dataset.id === handle);
        if (texto) texto.hidden = true;
        if (res) {
          res.hidden = false;
          if (!g) {   // recomendado pero fuera del listado visible
            res.innerHTML = `<a class="btn btn-pri btn-sm" href="/products/${handle}">Ver la variedad recomendada</a>`;
            return;
          }
          const foto = g.querySelector('.card-art img');
          const enlace = g.querySelector('a.card-art')?.getAttribute('href') || `/products/${handle}`;
          const agotado = g.querySelector('[data-add]')?.disabled;
          res.innerHTML = `
            <div style="display:flex;gap:16px;align-items:center">
              ${foto ? `<a href="${enlace}" style="flex:0 0 auto"><img src="${foto.currentSrc || foto.src}"
                   alt="" width="84" height="84" loading="lazy"
                   style="width:84px;height:84px;object-fit:cover;border-radius:4px"></a>` : ''}
              <div style="min-width:0">
                <p class="h-sm" style="margin:0 0 4px">${g.querySelector('h3').textContent}</p>
                <p class="mono" style="margin:0">${agotado ? 'Agotada ahora mismo' :
                  (g.querySelector('[data-total]')?.textContent || '') + ' · ' + (g.querySelector('[data-tramo]')?.textContent || '')}</p>
              </div>
            </div>
            <a class="btn btn-pri btn-sm" style="margin-top:14px" href="${enlace}">Ver la variedad</a>`;
        }
      }

      $$('[data-quiz] .chip', caja).forEach(chip => chip.addEventListener('click', () => {
        const k = chip.closest('[data-quiz]').dataset.quiz;
        elegido[k] = elegido[k] === chip.dataset.v ? '' : chip.dataset.v;
        pinta();
      }));
      pinta();
    })();

    /* pestañas de la ficha de producto */
    $$('.prod-tabs').forEach(caja => {
      const tabs = $$('.tab', caja), paneles = $$('.panel', caja);
      tabs.forEach(t => t.addEventListener('click', () => {
        tabs.forEach(x => x.setAttribute('aria-selected', x === t ? 'true' : 'false'));
        paneles.forEach(p => { p.hidden = p.dataset.panel !== t.dataset.tab; });
      }));
    });

    // capas
    $('#btn-cart')?.addEventListener('click', abrirCesta);
    $('#cart-x')?.addEventListener('click', cerrarTodo);
    $('#sheet-x')?.addEventListener('click', cerrarTodo);
    $('#veil')?.addEventListener('click', cerrarTodo);
    /* «Tramitar pedido» no llevaba ningún evento — no era un enlace ni un
       submit, así que pulsarlo no hacía nada. Va a /cart/checkout (con el
       idioma/mercado ya puestos por routes.cart_url) para entrar al
       checkout nativo de Shopify con la cesta actual. */
    $('#checkout')?.addEventListener('click', () => {
      window.location.href = `${ruta('cart_url', '/cart')}/checkout`;
    });
    /* Campo para pegar el código de descuento a mano en la propia cesta.
       Antes solo se podía aplicar por el enlace del email, y con la cesta
       vacía no pasaba nada visible, así que no había forma de saber si
       había funcionado. Ahora se puede escribir aquí, y el resultado se
       ve al momento en el propio resumen (línea de descuento o aviso de
       que el código no vale). */
    $('#cart-discount-form')?.addEventListener('submit', async e => {
      e.preventDefault();
      const input = $('#cart-discount-input');
      const msg = $('#cart-discount-msg');
      const code = input?.value.trim();
      if (!code) return;
      const boton = e.target.querySelector('button');
      if (boton) boton.disabled = true;
      if (msg) { msg.hidden = true; }
      try {
        const r = await fetch(`${ruta('cart_update_url', '/cart/update')}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        });
        const cesta = await r.json();
        pintaCesta(cesta);
        const aplicado = (cesta.discount_codes || [])
          .find(d => d.code.toLowerCase() === code.toLowerCase());
        if (msg) {
          msg.hidden = false;
          if (aplicado && aplicado.applicable) {
            msg.style.color = 'var(--gold)';
            msg.textContent = `Código «${code}» aplicado.`;
            input.value = '';
          } else {
            msg.style.color = 'var(--muted)';
            msg.textContent = `El código «${code}» no es válido para esta cesta.`;
          }
        }
      } catch (err) {
        if (msg) { msg.hidden = false; msg.style.color = 'var(--muted)'; msg.textContent = 'No se pudo aplicar el código, inténtalo de nuevo.'; }
      } finally {
        if (boton) boton.disabled = false;
      }
    });
    document.addEventListener('click', e => {
      if (e.target.closest('[data-close]')) cerrarTodo();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') cerrarTodo(); });

    // menú móvil
    $('#btn-menu')?.addEventListener('click', () => {
      $('#mnav')?.classList.add('on');
      document.body.classList.add('locked');
    });
    $('#btn-menu-x')?.addEventListener('click', cerrarTodo);
    $$('#mnav a').forEach(a => a.addEventListener('click', cerrarTodo));

    /* Portal de edad y cookies, con memoria.
       Antes no se guardaba nada, así que reaparecían en CADA página: al pulsar
       «Contacto» te volvía a preguntar la edad. Ahora se recuerda 30 días en una
       cookie propia (no hace falta consentimiento: es estrictamente necesaria
       para cumplir la restricción de edad). */
    const DIAS = 30;
    const leer = n => document.cookie.split('; ')
      .find(c => c.startsWith(n + '='))?.split('=')[1];
    const guardar = (n, v) => {
      const f = new Date(Date.now() + DIAS * 864e5).toUTCString();
      document.cookie = `${n}=${v};expires=${f};path=/;SameSite=Lax`;
    };

    const puerta = $('#gate');
    const avisoCookies = () => {
      if (!leer('gh_cookies')) setTimeout(() => $('#cookies')?.classList.add('on'), 700);
    };

    if (puerta) {
      if (leer('gh_edad') === 'si') {
        puerta.style.display = 'none';
        avisoCookies();
      }
      $('#gate-yes')?.addEventListener('click', () => {
        guardar('gh_edad', 'si');
        puerta.style.display = 'none';
        avisoCookies();
      });
      $('#gate-no')?.addEventListener('click', () => {
        const m = $('#gate-msg');
        if (m) m.style.display = 'block';
      });
    } else {
      avisoCookies();
    }

    $('#ck-min')?.addEventListener('click', () => {
      guardar('gh_cookies', 'min');
      $('#cookies')?.classList.remove('on'); toast('Solo cookies esenciales');
    });
    $('#ck-all')?.addEventListener('click', () => {
      guardar('gh_cookies', 'todas');
      $('#cookies')?.classList.remove('on'); toast('Preferencia guardada');
    });

    // cabecera al hacer scroll
    addEventListener('scroll', () => $('#hdr')?.classList.toggle('solid', scrollY > 20),
      { passive: true });

    // revelado
    if (typeof IntersectionObserver === 'function') {
      const io = new IntersectionObserver(
        es => es.forEach(en => en.isIntersecting && en.target.classList.add('in')),
        { threshold: .1, rootMargin: '0px 0px -6% 0px' });
      $$('.rv').forEach(el => io.observe(el));
    } else {
      $$('.rv').forEach(el => el.classList.add('in'));
    }
  });
})();
